<input
    required
    matInput
    data-test="input-text"
    class="input__field"
    autocomplete="off"
    name="text"
    [placeholder]="placeholder"
    [formControl]="text"
>